import styled from '@emotion/styled';

import { Text as Base } from './Text';

/**
 * Текст над формой кода подтверждения.
 */
export const Text = styled(Base)``;
